// extracted by mini-css-extract-plugin
export default {"v-local-padding":"16px","links":"links_JG3Um","linksItem":"linksItem_QlKGs"};